import React from "react";
import classes from "./DenOverview.module.css";
import nests from "../../Assets/Data/Nests";
import { useTranslation } from 'react-i18next';
import Icon from "../../components/UI/Icon/Icon";
import {getNest} from "../../Util/NestUtil";
import { Link } from "react-router-dom";
const fullpath = "https://raw.githubusercontent.com/Leanny/leanny.github.io/master/seedchecker/img/dens/";
const DenOverview = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();

    const prefix = [t("wildareas.0"), t("wildareas.1"), t("wildareas.2")]

    const dens = nests.map((nest, idx) => {
        return idx===16?null:
        <div className={classes.Wrapper} key={idx}>
            <h2 className={classes.Break} >{prefix[idx >= 190 ? 2 : idx >= 100 ? 1 : 0]} {t("misc:DEN")} {idx >= 190 ? idx - 189 : idx >= 100 ? idx - 99 : idx+1}: {t("translation:places."+nest[2])}</h2>
            {idx >= 100 ? <div className={classes.ImgWrapper}><a href={fullpath + "den_" + (idx+1) + ".jpg"}><img src={fullpath + "den_" + (idx+1) + ".jpg"} alt="den img" width="360px" /></a></div> : null }
            <div className={classes.Break} />
            <Link className={classes.Wrapper} to={"/dens/" + nest[0]}>
            <h3 className={classes.Break}>{t("misc:RARITYNORMAL")} ({t("misc:NEST")} {nest[0]})</h3>
            <div className={classes.GameWrapper}>
                <strong>{t("misc:GAMESWORD")}</strong>
                <div className={classes.Break} />
                {
                    getNest(0, nest[0]-1).map(
                        (entry, i) => {
                            return <Icon details={entry} key={i}/>
                        }
                    )
                }
            </div>
            <div className={classes.GameWrapper}>
                <strong>{t("misc:GAMESHIELD")}</strong>
                <div className={classes.Break} />
                {
                    getNest(1, nest[0]-1).map(
                        (entry, i) => {
                            return <Icon details={entry} key={i}/>
                        }
                    )
                }
            </div>
            </Link>
            <Link className={classes.Wrapper} to={"/dens/" + nest[1]}>
            <h3 className={classes.Break}>{t("misc:RARITYRARE")} ({t("misc:NEST")} {nest[1]})</h3>
            <div className={classes.GameWrapper}>
                <strong>{t("misc:GAMESWORD")}</strong>
                <div className={classes.Break} />
                {
                    getNest(0, nest[1]-1).map(
                        (entry, i) => {
                            return <Icon details={entry} key={i}/>
                        }
                    )
                }
            </div>
            <div className={classes.GameWrapper}>
                <strong>{t("misc:GAMESHIELD")}</strong>
                <div className={classes.Break} />
                {
                    getNest(1, nest[1]-1).map(
                        (entry, i) => {
                            return <Icon details={entry} key={i}/>
                        }
                    )
                }
            </div>
            </Link>
        </div>
    });

    return <>
    <h1>Pokémon Sword & Shield - Den Overview</h1>
            {dens}
    </>;
}

export default DenOverview;